import {plural, t} from '@lingui/core/macro';

import {ITariff} from 'entities/tariff';

export interface IFreeTariffFact {
    value: string,
    caption: string,
}

export const FREE_TARIFF_FACTS_MAX = 6;

export const getFreeTariffFacts = (tariffs: ITariff[]): IFreeTariffFact[] => {
    const free = tariffs.find((tariff) => !tariff.is_archive && 0 === tariff.price);

    if (!free) {
        return [];
    }

    const facts: IFreeTariffFact[] = [];

    if (free.monitor_max_count_limit > 0) {
        facts.push({
            value: plural(free.monitor_max_count_limit, {
                one: '# сайт',
                few: '# сайта',
                other: '# сайтов',
            }),
            caption: t`под наблюдением`,
        });
    }

    if (free.monitor_min_check_interval_limit > 0) {
        facts.push({
            value: plural(free.monitor_min_check_interval_limit, {
                one: 'Каждую # минуту',
                few: 'Каждые # минуты',
                other: 'Каждые # минут',
            }),
            caption: t`проверка доступности`,
        });
    }

    facts.push({
        value: t`Почта, Telegram, MAX`,
        caption: t`уведомления о сбоях`,
    });

    if (free.location_max_count_limit > 0) {
        facts.push({
            value: plural(free.location_max_count_limit, {
                one: '# точка проверки',
                few: '# точки проверки',
                other: '# точек проверки',
            }),
            caption: t`из разных сетей`,
        });
    }

    if (free.status_pages_max_count_limit > 0) {
        facts.push({
            value: plural(free.status_pages_max_count_limit, {
                one: '# страница статуса',
                few: '# страницы статуса',
                other: '# страниц статуса',
            }),
            caption: t`для ваших клиентов`,
        });
    }

    if (free.server_max_count_limit > 0) {
        facts.push({
            value: plural(free.server_max_count_limit, {
                one: '# сервер',
                few: '# сервера',
                other: '# серверов',
            }),
            caption: t`процессор, память и диск`,
        });
    }

    if (free.port_monitor_max_count_limit > 0) {
        facts.push({
            value: plural(free.port_monitor_max_count_limit, {
                one: '# порт',
                few: '# порта',
                other: '# портов',
            }),
            caption: t`доступность TCP-портов`,
        });
    }

    if (free.domain_monitor_max_count_limit > 0) {
        facts.push({
            value: plural(free.domain_monitor_max_count_limit, {
                one: '# домен',
                few: '# домена',
                other: '# доменов',
            }),
            caption: t`срок регистрации и SSL`,
        });
    }

    return facts.slice(0, FREE_TARIFF_FACTS_MAX);
};
